import ReactGA from 'react-ga';

import config from '$/config';
import { logger } from '$/utils/logger';
import { MeFragment } from '$/GraphQL/schema/types';

export class AnalyticsProxy {
  constructor() {
    if (config.isSSR) {
      return;
    }

    ReactGA.initialize(config.GA_TRACKING_CODE, {
      debug: config.isLocal,
    });
  }

  page(pathname: string): void {
    if (config.isSSR) {
      return;
    }

    try {
      ReactGA.pageview(pathname);
    } catch (e: any) {
      logger.error(e);
    }
  }

  track(data: Record<string, string>, heapData?: Record<string, string>): void {
    if (config.isSSR) {
      return;
    }

    const { event, ...rest } = data;
    const { event: heapEvent, ...heapRest } = heapData || data;

    try {
      ReactGA.event({ category: 'event', action: event });
      window.dataLayer?.push({ event, ...rest });
      window.heap?.track(heapEvent, heapRest);
    } catch (e: any) {
      logger.error(e);
    }
  }

  identify(me: MeFragment): void {
    if (config.isSSR) {
      return;
    }

    try {
      const heap = window.heap;
      if (!heap) {
        logger.error('No Heap object found');
      } else {
        // In the past we passed in teamId for identity.  We are trying to break/correct that
        // We also were merging identities when cloaked so we need to break that as well
        // by seeing if the current identity isn't the same as the one we're trying to set
        if (heap.identity != me.id) {
          heap.resetIdentity();
        }
        heap.identify(me.id);
        heap.addUserProperties({
          email: me.email,
          company: { id: me.team.id, name: me.team.name },
        });
      }

      ReactGA.set({
        userId: `${me.id}`,
        teamId: `${me.team.id}`,
      });
    } catch (e) {
      logger.error('Error in identity', e as Error);
    }
  }

  resetIdentity() {
    window.heap?.resetIdentity();
  }
}
